import request from '@/router/axios';

/**
 * 获取报告附件下的批注列表
 * @param {附件记录ID} annexId 
 */
export const getMarkList = (annexId) => {
    return request('/api/lab/task2mark/queryByAnnex', { params: { annexId } });
};

/**
 * 添加批注
 * @param {*} data 
 */
export const addMark = data => {
    return request('/api/lab/task2mark', { data }, 'post');
};

/**
 * 修改批注
 * @param {*} data 
 */
export const updateMark = (data) => {
    return request('/api/lab/task2mark', { data }, 'put');
};
 
/** 
 *批量删除批注
 * @param {Array} data
 */
export const delMark = data => {
    return request('/api/lab/task2mark/deleteBatch', { data }, 'delete');
};
